import { ICoinflipGame } from "@api/types/Coinflip";
import { ApolloError, useMutation } from "@apollo/client";
import { CANCEL_COINFLIP_GAME } from "@graphql/Mutations";
import { useCallback, useState } from "react";
import useReduxState from "./useReduxState";

export default function useCancelCoinflipGame(
  coinflip: ICoinflipGame,
  {
    onCompleted,
    onError,
  }: {
    // eslint-disable-next-line no-unused-vars
    onCompleted: (game: ICoinflipGame) => void;
    // eslint-disable-next-line no-unused-vars
    onError: (error: ApolloError) => void;
  }
): () => Promise<void> {
  const [user] = useReduxState((state) => state.userData);
  const [isCancelling, setIsCancelling] = useState<boolean>(false);
  const [cancelCoinflipGame] = useMutation(CANCEL_COINFLIP_GAME, {
    onCompleted: ({ joinCoinflipGame }) => {
      setIsCancelling(false);
      onCompleted(joinCoinflipGame);
    },
    onError: (e) => onError(e),
  });

  const cancelGame = useCallback(async () => {
    if (!isCancelling) {
      setIsCancelling(true);
      await cancelCoinflipGame({
        variables: {
          gameUid: coinflip.uid,
          userId: user.id,
        },
      });
    }
  }, [coinflip, isCancelling]);

  return cancelGame;
}
